import React, {Component} from 'react';
import {Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Col, OverlayTrigger, Row, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import {HiOutlineViewList} from "react-icons/hi";
import Moment from "react-moment";

function getPricesNewsletter() {

    return fetch('https://backapi.therunningcollective.fr/api/protected/newsletter/prices', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
        },
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class NewsletterPricesGlobalPageList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pricesNewsletter: null,
        }

    }

    async componentDidMount() {
        await getPricesNewsletter().then(data => {
            const prices = data.reduce((price, object) => {
                (price[object.productName] = price[object.productName] || []).push(object);
                return price;
            }, {});
            let newArray = new Array()

            for(let i in prices){
                let average = 0
                let sum = 0
                let lengthOfProduct = 0
                for(let j in prices[i]){
                    if (prices[i][j].researchedPrice >  0){
                        sum += prices[i][j].researchedPrice
                        lengthOfProduct++
                    }
                }
                average = sum / lengthOfProduct

                newArray.push({
                    name: i,
                    length: prices[i].length,
                    average: average.toFixed(1)
                    }
                )
            }
            newArray.sort((a,b) => (a.length < b.length) ? 1 : ((b.length < a.length) ? -1 : 0))

            this.setState({pricesNewsletter: newArray})
        }).catch(err =>
            this.setState({errors: "error while getting pricesNewsletter"})
        );
    };

    renderTooltipImg = (declination) => (
        <Tooltip id="button-tooltip" >
            {declination ?
                <div key={declination.reference}>
                    <div>
                        <img className="imgToDisplay" alt="Couverture" src={"https://img.therunningcollective.fr/" + declination.declinationImg}/>
                    </div>
                    <br/>
                </div>
                : "Indisponible" }
        </Tooltip>
    );


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={1} className="products-buttons">
                        <ToggleButtonGroup value={this.state.mode} type="checkbox">
                            <ToggleButton
                                key={2}
                                type="radio"
                                variant="secondary"
                                name="radio"
                                value={"Liste"}
                                onChange={(e) => this.setState({mode: e.currentTarget.value})}
                            >
                                <HiOutlineViewList/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Col>
                </Row>
                { this.state.errors != null ? <p>"Erreur lors de la récupération des pricesNewsletter, veuillez vous reconnecter"</p> : null}

                { (!this.state.pricesNewsletter && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>
                        <tr>
                            <th>Nom du produit</th>
                            <th>Nombre de recherche</th>
                            <th>Prix moyen recherché</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.state.pricesNewsletter.map(price => (
                            <tr
                                key={price.name}
                                id={price.name}
                            >
                                <td>{price.name} </td>
                                <td>{price.length}</td>
                                <td>{price.average}€</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                }
            </div>
        );

    }
}